const IconSecondStep = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101.95"
      height="89.857"
      viewBox="0 0 101.95 89.857"
    >
      <g id="undraw_delivery_address_re_cjca" transform="translate(0 0)">
        <path
          id="Trazado_625"
          data-name="Trazado 625"
          d="M168.752,215.347a3.55,3.55,0,0,0-2.512,2.354c-.328,1.34.429,2.691.538,4.068.354,4.509-6.061,7.69-5.146,12.12.363,1.761,1.832,3.057,3.279,4.127a17.851,17.851,0,0,0,7.739,3.645c4.323.648,8.841-1.256,13.043-.053,3.389.971,5.983,3.816,9.349,4.865,2.562.8,5.323.484,7.985.161a8.41,8.41,0,0,0,4.1-1.236c2.153-1.6,2.289-4.769,3.73-7.038,2.227-3.5,7.109-4.186,11.2-3.506s8.069,2.354,12.217,2.218a5.576,5.576,0,0,0,2.568-.585,6.37,6.37,0,0,0,2.137-2.381,38.528,38.528,0,0,0,5.587-19.144,6.872,6.872,0,0,0-.563-3.4,6.213,6.213,0,0,0-3.446-2.6c-3.3-1.256-6.947-1.461-10.181-2.878-3.119-1.366-5.646-3.763-8.362-5.816a44.543,44.543,0,0,0-18.346-8.17,11.63,11.63,0,0,0-4.73-.169,11.211,11.211,0,0,0-4.71,2.713c-3.683,3.189-6.634,7.123-10.028,10.617a57.092,57.092,0,0,1-7.619,6.57,27.762,27.762,0,0,1-3.991,2.649C171.308,215.093,170.107,214.939,168.752,215.347Z"
          transform="translate(-149.371 -172.222)"
          fill="rgba(133,196,64,0.5)"
          opacity="0.2"
        />
        <path
          id="Trazado_529"
          data-name="Trazado 529"
          d="M676.618,704.771l-.25-3.479a11.256,11.256,0,0,0-5.284-1.185c2.577,1.992,2.37,5.972,4.155,8.7a6.77,6.77,0,0,0,5.048,2.992l2.144,1.234a11.344,11.344,0,0,0-2.641-9.123,10.96,10.96,0,0,0-2.064-1.815C677.257,703.436,676.618,704.771,676.618,704.771Z"
          transform="translate(-611.145 -623.635)"
          fill="#f2f2f2"
        />
        <path
          id="f02c4e45-f306-4b42-b3ad-5ddd3016d7d2"
          d="M612.591,804.084h49.092a.157.157,0,1,0,0-.315H612.591a.157.157,0,1,0,0,.315Z"
          transform="translate(-559.891 -714.228)"
          fill="#ccc"
        />
        <path
          id="Trazado_530"
          data-name="Trazado 530"
          d="M333.376,244.136v.067h.047A.67.67,0,0,1,333.376,244.136Zm.361-28.543a24.339,24.339,0,0,0-5.044,14.864q0,1.228.12,2.421c.012.137.026.273.045.408A24.282,24.282,0,0,0,333,244.3c.088.129.177.255.267.381a24.445,24.445,0,0,0,37.861,2.389c.141-.149.275-.3.408-.451a24.423,24.423,0,0,0,1.071-31.03c-.1-.137-.21-.273-.32-.408q-.362-.456-.751-.893c-.133-.151-.267-.3-.408-.451a24.4,24.4,0,0,0-17.955-7.862c-.235,0-.467,0-.7.01q-.233.006-.465.018a24.434,24.434,0,0,0-17.949,9.177C333.947,215.319,333.841,215.456,333.737,215.593Zm-.314,28.611a.674.674,0,0,1-.047-.067v.067Z"
          transform="translate(-311.932 -191.824)"
          fill="#fff"
        />
        <path
          id="Trazado_531"
          data-name="Trazado 531"
          d="M363.03,243.956l.069-.141,5.193-10.458v0l.2-.406v0l8.579-17.283v0l.2-.406,0,0,4.345-8.757.208-.418q.233-.012.465-.018l-.206.416-4.357,8.777v0l-.2.406v0l-8.8,17.734,0,0-5.193,10.466-.2.408-.033.067-.206.414c-.09-.126-.18-.253-.267-.381Z"
          transform="translate(-341.758 -191.895)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_532"
          data-name="Trazado 532"
          d="M339.648,419.279v.408h-9.956c-.018-.135-.033-.271-.045-.408Z"
          transform="translate(-312.766 -378.225)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_533"
          data-name="Trazado 533"
          d="M531.647,441.687v-.408H541.6c.018.135.033.271.045.408Z"
          transform="translate(-489.292 -397.451)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_534"
          data-name="Trazado 534"
          d="M597.682,433.243h.408V443.2c-.135.018-.271.033-.408.045Z"
          transform="translate(-547 -390.428)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_535"
          data-name="Trazado 535"
          d="M407.56,270.07c-.1-.137-.21-.273-.32-.408h-.751v-.893c-.133-.151-.267-.3-.408-.451v1.344H369.014c-.11.135-.216.271-.32.408h37.388V301.55c.141-.149.275-.3.408-.451V270.07Z"
          transform="translate(-346.889 -246.301)"
          fill="#3f3d56"
        />
        <rect
          id="Rectángulo_239"
          data-name="Rectángulo 239"
          width="37.954"
          height="0.408"
          transform="translate(21.443 51.971)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_536"
          data-name="Trazado 536"
          d="M333.376,244.136v.067h.047A.67.67,0,0,1,333.376,244.136Zm.361-28.543a24.339,24.339,0,0,0-5.044,14.864q0,1.228.12,2.421c.012.137.026.273.045.408A24.282,24.282,0,0,0,333,244.3c.088.129.177.255.267.381a24.445,24.445,0,0,0,37.861,2.389c.141-.149.275-.3.408-.451a24.423,24.423,0,0,0,1.071-31.03c-.1-.137-.21-.273-.32-.408q-.362-.456-.751-.893c-.133-.151-.267-.3-.408-.451a24.4,24.4,0,0,0-17.955-7.862c-.235,0-.467,0-.7.01q-.233.006-.465.018a24.434,24.434,0,0,0-17.949,9.177C333.947,215.319,333.841,215.456,333.737,215.593Zm-4.469,17.694c-.018-.135-.033-.271-.047-.408a24.074,24.074,0,0,1,5.03-17.286c.108-.137.216-.273.328-.408a24.039,24.039,0,0,1,17.218-8.759c.155-.008.31-.016.467-.02q.45-.018.906-.018a24,24,0,0,1,17.955,8.057c.141.155.277.31.408.469.08.09.155.179.229.271.112.135.22.271.328.408A24.022,24.022,0,0,1,371.533,246c-.131.159-.267.314-.408.469a24.042,24.042,0,0,1-37.655-2.2c-.016-.022-.033-.045-.047-.067a.666.666,0,0,1-.047-.067q-.089-.125-.171-.251a23.856,23.856,0,0,1-3.937-10.6Zm4.155,10.917a.674.674,0,0,1-.047-.067v.067Z"
          transform="translate(-311.932 -191.824)"
          fill="#ccc"
        />
        <path
          id="Trazado_537"
          data-name="Trazado 537"
          d="M569.307,510.491H544.886a1.128,1.128,0,0,1-1.126-1.126v-11.9a1.128,1.128,0,0,1,1.126-1.126h24.421a1.128,1.128,0,0,1,1.126,1.126v11.9A1.127,1.127,0,0,1,569.307,510.491Z"
          transform="translate(-499.877 -445.566)"
          fill="#cacaca"
        />
        <path
          id="Trazado_538"
          data-name="Trazado 538"
          d="M563.793,514.777c-5.348,0-10.925-.051-13.006-.084a1.049,1.049,0,0,1-1.028-1.045V502.71a.371.371,0,0,1,.37-.37h24.421a.371.371,0,0,1,.37.369v7.421a4.63,4.63,0,0,1-4.552,4.612C568.428,514.767,566.132,514.777,563.793,514.777Z"
          transform="translate(-505.12 -450.81)"
          fill="#e4e4e4"
        />
        <path
          id="Trazado_539"
          data-name="Trazado 539"
          d="M568.741,503.942h-19.87a.626.626,0,0,1-.588-.415l-2.249-6.31a.625.625,0,0,1,.587-.834l24.838-.035h0a.625.625,0,0,1,.574.871L572,497.2l.034.015-2.719,6.344A.624.624,0,0,1,568.741,503.942Z"
          transform="translate(-501.833 -445.575)"
          fill="#cacaca"
        />
        <path
          id="Trazado_540"
          data-name="Trazado 540"
          d="M562.561,582.415h-6.852a.637.637,0,0,1,0-1.273h6.852a.637.637,0,0,1,0,1.273Z"
          transform="translate(-509.763 -519.675)"
          fill="#cacaca"
        />
        <circle
          id="Elipse_6"
          data-name="Elipse 6"
          cx="1.556"
          cy="1.556"
          r="1.556"
          transform="translate(55.626 56.811)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_541"
          data-name="Trazado 541"
          d="M203.729,96.953a17.631,17.631,0,0,1,24.567,4.264c5.607,7.961,11.233,28.838,7.261,40.932-11.845-12.512-30.044-13.812-36.092-20.628C193,114.237,195.768,102.56,203.729,96.953Z"
          transform="translate(-195.863 -93.736)"
          fill="#85c440"
        />
        <circle
          id="b262ea8c-1946-46c9-a449-3a1996c39394"
          cx="5.75"
          cy="5.75"
          r="5.75"
          transform="translate(12.507 9.745)"
          fill="#fff"
        />
        <circle
          id="bcc29a3a-8123-4529-80aa-6f70df2823cf"
          cx="3.766"
          cy="3.766"
          r="3.766"
          transform="translate(40.789 47.143)"
          fill="#85c440"
        />
        <path
          id="Trazado_542"
          data-name="Trazado 542"
          d="M286.337,196.2a5.75,5.75,0,1,0,9.931,5.8,5.749,5.749,0,0,1-8.754-7.225A5.75,5.75,0,0,0,286.337,196.2Z"
          transform="translate(-274.232 -182.035)"
          fill="#231f20"
          opacity="0.2"
        />
        <path
          id="Trazado_543"
          data-name="Trazado 543"
          d="M199.382,154.62c6.048,6.816,24.247,8.116,36.092,20.629a24.388,24.388,0,0,0,.851-3.5c-11.84-11.375-29.025-12.812-34.868-19.4-5.23-5.894-4.416-14.666.3-20.769C195.287,137.582,193.459,147.945,199.382,154.62Z"
          transform="translate(-195.791 -126.808)"
          fill="#231f20"
          opacity="0.2"
        />
        <path
          id="Trazado_544"
          data-name="Trazado 544"
          d="M762.4,500.087l-2.442-.744c-1.063,1.282-1.944,4.994-1.944,4.994l-3.342,5.431a1.127,1.127,0,1,0,1.607,1.1l5.058-6.141Z"
          transform="translate(-683.632 -448.192)"
          fill="#ffb6b6"
        />
        <path
          id="Trazado_545"
          data-name="Trazado 545"
          d="M789.639,465.68l.451-3.7-1.012-1.689a2.072,2.072,0,0,0-1.949-.994h0a2.067,2.067,0,0,0-1.879,2.107c.038,1.589.288,3.6,1.265,4.147l.01.006Z"
          transform="translate(-710.914 -413.193)"
          fill="#85c440"
        />
        <path
          id="Trazado_546"
          data-name="Trazado 546"
          d="M645.091,641.926l-1.464.707-3.423-5.312,2.161-1.043Z"
          transform="translate(-559.467 -556.037)"
          fill="#ffb6b6"
        />
        <path
          id="Trazado_547"
          data-name="Trazado 547"
          d="M848.268,774.177l-4.5,2.174-.027-.057a1.946,1.946,0,0,1,.906-2.6h0l.521-1.021,1.836-.117.393-.19Z"
          transform="translate(-761.856 -686.785)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_548"
          data-name="Trazado 548"
          d="M575.9,653.3h-1.626l-.774-6.272h2.4Z"
          transform="translate(-501.176 -565.436)"
          fill="#ffb6b6"
        />
        <path
          id="Trazado_549"
          data-name="Trazado 549"
          d="M754.123,785.226h-5v-.063a1.946,1.946,0,0,1,1.946-1.946h0l.913-.693,1.7.693h.436Z"
          transform="translate(-679.342 -695.661)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_550"
          data-name="Trazado 550"
          d="M761.531,554.426l-1.863,12.849.507,1.691-.665,1.2.977,9.012-.4.873,1.108.683h2.255l.12-9.52.557-1.4v-.77l1.134-5.805.262,9.037.362.7c1.348,3.06,3.165,4.061,4.449,6.348l2.255-1.221-.047-.911c.453-.229-.68-.9-.789-1.4l-.2-.888-1.316-2.725-.05-.96.36-6.527-.169-8.789-2.958-2.262Z"
          transform="translate(-688.419 -495.645)"
          fill="#2f2e41"
        />
        <circle
          id="Elipse_7"
          data-name="Elipse 7"
          cx="2.93"
          cy="2.93"
          r="2.93"
          transform="translate(73.11 37.337)"
          fill="#ffb6b6"
        />
        <path
          id="Trazado_551"
          data-name="Trazado 551"
          d="M764.132,461.53l-.043-.015.567-1.843a1.5,1.5,0,0,1,.271-1.4,1.274,1.274,0,0,1,.146-1.545,2.032,2.032,0,0,1,.424-1.822s1.254-9.5,1.957-12.013c.02-.184-.144-1.683.8-1.742l2.371-.151c.145-.01.23.235.359.634.087.27-.362.639-.253.633h.008l.007,0a4.723,4.723,0,0,1,3.493,4.827l-.334,5.678c.051.228,1.114,6.7.836,7.4-.158.394.111.64.308.819.1.092.174.159.164.232a.122.122,0,0,1-.076.089c-.178.089-.08.7.024,1.061l.011.037-.034.018a20.125,20.125,0,0,0-7.081-1.438C766.6,460.989,765.76,462.1,764.132,461.53Z"
          transform="translate(-692.421 -397.205)"
          fill="#85c440"
        />
        <path
          id="Trazado_552"
          data-name="Trazado 552"
          d="M774.251,383.327a.244.244,0,0,1-.124-.155l-.042-.17.128.134a.507.507,0,0,0-.148-.867,1.062,1.062,0,0,0-.173-.042,1.206,1.206,0,0,1-.182-.044.827.827,0,0,1-.5-.7,2.193,2.193,0,0,1,.087-.787,10.722,10.722,0,0,1-3.89-.117,1.805,1.805,0,0,1-.558-.22,2.162,2.162,0,0,1-.764-.769.231.231,0,0,1,.031-.272.251.251,0,0,1,.183-.08l-.047-.127a.239.239,0,0,1,.268-.317l.166.031-.016-.11a.239.239,0,0,1,.32-.258.263.263,0,0,0,.35-.193l.057-.277.006-.015a2.158,2.158,0,0,1,1.479-.932,6.319,6.319,0,0,1,1.769,0,1.619,1.619,0,0,1,.707.179.618.618,0,0,1,.308.57,1.411,1.411,0,0,1,1.488.616,3.092,3.092,0,0,1,.429,1.7,4.924,4.924,0,0,1-.745,2.96.7.7,0,0,1-.322.286.33.33,0,0,1-.106.017A.343.343,0,0,1,774.251,383.327Z"
          transform="translate(-695.89 -341.259)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_553"
          data-name="Trazado 553"
          d="M741.839,509.264l-2.151-1.375c-1.369.947-3.22,4.284-3.22,4.284l-4.684,4.327a1.127,1.127,0,1,0,1.249,1.5l6.528-4.548Z"
          transform="translate(-663.372 -455.66)"
          fill="#ffb6b6"
        />
        <path
          id="Trazado_554"
          data-name="Trazado 554"
          d="M792.333,475.719l1.432-3.438-.518-1.9a2.072,2.072,0,0,0-1.608-1.483h0a2.067,2.067,0,0,0-2.378,1.521c-.392,1.54-.694,3.542.1,4.334l.008.008Z"
          transform="translate(-714.071 -421.557)"
          fill="#85c440"
        />
      </g>
    </svg>
  );
};

export default IconSecondStep;
